export const DOCUMENT_GENERATION_HISTORY_PAGE_SIZE = 10;

export const DOCUMENT_GENERATION_HISTORY_LABELS = {
  title: 'Оберіть джерело для',
  description: 'Оберіть раніше збережені дані або створіть новий документ.',
  empty: 'Історичних записів не знайдено.',
  cancel: 'Скасувати',
  createNew: 'Створити новий',
  continue: 'Продовжити',
  select: 'Використати',
  selectStateAidType: 'Оберіть тип довідки для перегенерації документа.',
  recordPrefix: 'Запис №',
  deadlinePrefix: 'до',
  versionPrefix: 'Версія',
} as const;
